var React = require('react');

function ManWithCross (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#ffdb00","strokeWidth":"1.2","d":"M31.351 10.712c0 5.563-4.692 10.112-10.529 10.112-5.836 0-10.529-4.549-10.529-10.112S14.986.6 20.823.6C26.658.6 31.35 5.149 31.35 10.712z","key":0}),React.createElement("path",{"stroke":"#ffdb00","strokeWidth":"1.2","d":"M40.57 45c0-10.518-8.858-19.044-19.785-19.044S1 34.482 1 45","key":1}),React.createElement("line",{"x2":"18","y1":"-.5","y2":"-.5","stroke":"#ffdb00","transform":"scale(1 -1) rotate(45 53.97 35.627)","key":2}),React.createElement("line",{"x1":"54.156","x2":"41.428","y1":"28.082","y2":"15.354","stroke":"#ffdb00","key":3})]);
}

ManWithCross.defaultProps = {"fill":"none","viewBox":"0 0 66 45"};

module.exports = ManWithCross;

ManWithCross.default = ManWithCross;
